import { useEffect, useState } from 'react';

const match = (query) =>
  typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query).matches : false;

/** Suit une media query (ex. « (min-width: 1024px) »). */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => match(query));

  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else mql.addListener(onChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange);
      else mql.removeListener(onChange);
    };
  }, [query]);

  return matches;
}

// Points de rupture partagés (UI-04)
export const MOBILE_QUERY = '(max-width: 767.98px)';
export const DOCKED_PANEL_QUERY = '(min-width: 1024px)';
